var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["msg", { closed: _vm.isCollapsed }],
      attrs: { "data-type": "condensed" },
    },
    [
      _c("div", { staticClass: "condensed-summary" }, [
        _c("span", { staticClass: "time" }),
        _c("span", { staticClass: "from" }),
        _c(
          "span",
          { staticClass: "content", on: { click: _vm.onCollapseClick } },
          [
            _vm._v(_vm._s(_vm.condensedText)),
            _c("button", {
              staticClass: "toggle-button",
              attrs: { "aria-label": "Toggle status messages" },
            }),
          ]
        ),
      ]),
      _vm._l(_vm.messages, function (message) {
        return _c("Message", {
          key: message.id,
          attrs: { network: _vm.network, message: message },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }